import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { BancoResponse } from 'src/app/global/interfaces/banco-response';
import { BancoService } from 'src/app/global/services/banco.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class BancoProvider extends BancoService {

    private baseUrl = _.get(environment, 'api.host', '');
    private basePath = _.get(environment, 'api.path', '');
    private baseEndpoint = _.get(environment, 'api.endpoints', '');
    private endpoint: string;


    constructor(private http: HttpClient) {
        super();
    }

    getBancos(): Observable<BancoResponse[]> {

        this.endpoint = this.baseUrl + this.basePath + _.get(this.baseEndpoint, 'PASO_2.BANCO');

        return this.http.get<BancoResponse[]>(this.endpoint);

    }



}
